const reducer = (state = { label: '--select--', id: '--select--' }, action) =>{
    switch(action.type){
        case "setAdhocPaymentSearch": 
            return action.payload;
        default: 
            return state;
    }
}

export default reducer;  